<template>
  <LoadingWrapper :state="status">
    <SideBarLayoutContent v-if="member">
      <template #top-bar>
        <div class="flex grow items-center gap-4">
          <BaseMemberAvatar size="56" :member="member" omit-tooltip />
          <h1 class="text-display-small grow">{{ memberFullName(member) }}</h1>
          <BaseIconButton
            v-tooltip="$t('member.accessCode.tooltip')"
            color="tonalPrimary"
            icon="password"
            @click="openDialog"
          />
        </div>
      </template>
      <BaseTabGroup :tab-items="tabItems">
        <BaseTabBar :tab-items="tabItems" class="mb-4 border-b" />
        <TabPanels>
          <TabPanel>
            <MemberProfile />
          </TabPanel>
        </TabPanels>
      </BaseTabGroup>
    </SideBarLayoutContent>
    <MemberAccessCodeDialog
      :is-open="isOpen"
      :member-id="member?.id"
      :member-name="memberFullName(member)"
      @close="closeDialog"
    />
  </LoadingWrapper>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { TabPanel, TabPanels } from '@headlessui/vue'
  import { useI18n } from 'vue-i18n'
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import BaseTabBar from '@/core/components/base/tab-bar/BaseTabBar.vue'
  import BaseTabGroup from '@/core/components/base/tab-bar/BaseTabGroup.vue'
  import { memberFullName } from '@/core/models/member/member-name'
  import { useOrganizationMember } from '../composables/use-organization-member'
  import MemberAccessCodeDialog from '../components/MemberAccessCodeDialog.vue'
  import MemberProfile from '../components/MemberProfile.vue'
  import { useDialog } from '@/core/components/base/dialog/use-dialog.ts'
  import BaseIconButton from '@/core/components/base/button/icon-button/BaseIconButton.vue'

  const { t } = useI18n()
  const { member, status } = useOrganizationMember()

  const { isOpen, openDialog, closeDialog } = useDialog()

  const tabItems = computed(() => [{ id: 'profile', title: t('member.profile') }])
</script>
